var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main not-found my-10"},[_c('Error404')],1)}
var staticRenderFns = []

export { render, staticRenderFns }